import { useState, useEffect } from 'react';
import { fetchSlotDailySales } from '../../../data/machinesApi';

const useSlotDailySales = (storeId, productId, clientId, period) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!storeId || !productId || !clientId) {
      setData(null);
      return;
    }

    let cancelled = false;
    setLoading(true);

    fetchSlotDailySales(clientId, storeId, productId, period)
      .then(result => {
        if (!cancelled) setData(result);
      })
      .catch(() => {
        if (!cancelled) setData(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [storeId, productId, clientId, period]);

  return { data, loading };
};

export default useSlotDailySales;
